import { Component, OnDestroy, OnInit, HostListener } from '@angular/core';
import { Firestore, doc, DocumentReference } from '@angular/fire/firestore';
import { Observable, takeUntil, Subject } from 'rxjs';
import { User } from '@angular/fire/auth';
import { UserDocument } from '../../interfaces/user-document.interface';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { DataService } from '../../services/data.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class Home implements OnInit, OnDestroy {
  userData: UserDocument | null = null;
  private destroy$ = new Subject<void>();
  user$: Observable<User | null>;
  userDocRef: DocumentReference | null = null;
  member: boolean = false;
  showUserFunctions: boolean = false;

  get isPlatformAdmin(): boolean {
    return this.dataService.hasRole('platform.admin');
  }

  constructor(
    private dataService: DataService,
    private firestore: Firestore,
    public authService: AuthService,
    private router: Router,
  ) {
    this.user$ = this.authService.userSubject;
  }

  ngOnInit(): void {
    this.listenUserData();
  }

  private listenUserData(): void {
    this.dataService.userData$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((userData) => {
      this.userData = userData;
      const currentAuthUser = this.authService.userSubject.getValue();

      if (userData && currentAuthUser) {
        this.userDocRef = doc(this.firestore, `User/${currentAuthUser.uid}`);
      }
      this.member = (this.userData?.diamonds || 0) >= 5000;
    });
  }

  private closeAllChildren(): void {
    this.showUserFunctions = false;
  }

  navigatePaymentCenter() { this.router.navigate(['payment-center']); }
  navigateControlCenter() { this.router.navigate(['controlCenter']); }
  navigateToQlyFoods(): void { this.router.navigate(['food-management']); }
  navigateToQlyMissions(): void { this.router.navigate(['mission-management']); }
  navigateToQlyServices(): void { this.router.navigate(['service-management']); }
  navigateAdManagement(): void { this.router.navigate(['ad-management']); }
  navigatePriceEditor(): void { this.router.navigate(['price-editor']); }
  navigateAIManagement(): void { this.router.navigate(['ai-settings']); }

  toggleGiftersList(): void {
    if (!this.userData) { this.authService.signOut(); return; }
    this.closeAllChildren();
  }

  toggleUserFunctions(): void {
    if (!this.userData) { this.authService.signOut(); return; }
    const currentState = this.showUserFunctions;
    this.closeAllChildren();
    this.showUserFunctions = !currentState;
  }

  signOut(): void { this.authService.signOut(); }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    const userFunctionsTrigger = document.querySelector('.user-functions');
    const userFunctionsDropdown = document.querySelector('.user-functions-dropdown');
    if (this.showUserFunctions && userFunctionsTrigger && !userFunctionsTrigger.contains(target) && userFunctionsDropdown && !userFunctionsDropdown.contains(target)) {
        this.showUserFunctions = false;
    }
  }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
